import { useState } from "react"
import { Container, Nav, Tab } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { parsedUser } from "../../common/GetCurrentUser"
import ActionBar from "@/components/core/ActionBar"
import DispatchCategoryDrilldownPage from "../indicators/DispatchCategoryDrilldownPage"
import WarehouseAnalysis from "./WarehouseAnalysis"
import MerchandiseSearch from "./MerchandiseSearch"

export default function AnalysisPage() {
  const { t } = useTranslation("global")
  const user: any = parsedUser()
  const orgId = user?.OrganizationId || user?.organizationId || ""

  const [activeTab, setActiveTab] = useState("conceptSearch")

  return (
    <Container fluid className="px-4 py-3">
      <Tab.Container activeKey={activeTab} onSelect={k => setActiveTab(k || "conceptSearch")} mountOnEnter>
        <ActionBar
          title={t("Analysis")}
          icon="fas fa-chart-line text-primary"
          actions={
            <Nav variant="pills">
              <Nav.Item>
                <Nav.Link eventKey="conceptSearch">
                  <i className="fas fa-magnifying-glass-chart me-1" />{t("Concept Search")}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="byCategory">
                  <i className="fas fa-tags me-1" />{t("By Category")}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="byWarehouse">
                  <i className="fas fa-warehouse me-1" />{t("By Warehouse")}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          }
        />

        <Tab.Content className="mt-3">
          <Tab.Pane eventKey="conceptSearch">
            <MerchandiseSearch orgId={orgId} />
          </Tab.Pane>
          <Tab.Pane eventKey="byCategory">
            <DispatchCategoryDrilldownPage embedded orgId={orgId} />
          </Tab.Pane>
          <Tab.Pane eventKey="byWarehouse">
            <WarehouseAnalysis orgId={orgId} />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Container>
  )
}
